import React from 'react'
import Typography from '@material-ui/core/Typography'

interface YumMediumTitleProps {
  /**
   * The text content to display in the title
   */
  children: React.ReactNode

  /**
   * Additional styles to apply to the title
   */
  style?: React.CSSProperties
}

/**
 * Reusable medium title component with consistent styling.
 * Uses Material-UI Typography with predefined styles for medium-sized section titles.
 */
export default function YumMediumTitle({ children, style = {} }: YumMediumTitleProps) {
  return (
    <Typography
      variant="h2"
      style={{ fontWeight: 500, fontSize: '1rem', marginTop: '1.3125rem', marginBottom: '0.6875rem', ...style }}
    >
      {children}
    </Typography>
  )
}
